import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Channel from './children/channel';

class Channels extends Component {
	renderChannels() {
		const { availableChannels, status } = this.props;
		if (availableChannels && availableChannels.length) {
			return availableChannels.map(channel => (
				<Channel key={`channel-${channel.id}`} channel={channel} />
			));
		}
		if (status === 'initialized') {
			return <div>No public channels could be found...</div>;
		}
		return <div>Loading...</div>;
	}

	render() {
		return (
			<div>
				<span>Channels</span>

				{this.renderChannels()}
			</div>
		);
	}
}

Channels.propTypes = {
	status: PropTypes.string.isRequired,
};

Channels.defaultProps = {};

export default Channels;



// WEBPACK FOOTER //
// ./src/ui/channels/Channels.component.js